import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { datadogRum } from '@datadog/browser-rum';

if (environment.production) {
  enableProdMode();
}

if (environment.datadog) {
  datadogRum.init({
    applicationId: environment.datadog_applicationId,
    clientToken: environment.datadog_clientToken,
    site: environment.datadog_site,
    //  service: 'my-web-application',
    env: environment.datadog_env,
    //  version: '1.0.0',
    sampleRate: 100,
    trackInteractions: true,
  });
}

platformBrowserDynamic().bootstrapModule(AppModule);
